<template>
  <div v-if="show" class="footer-mask-component">
    <div class="footer-mask-content box">
      <img class="icon-footer-logo" src="./img/icon_footer_slogan.png" />
      <img class="icon-footer-wechatmini" src="./img/icon_footer_wechatmini.png" />
    </div>
    <div
      class="footer-close-image"
      @click="$emit('close')"
    >
      <img
        class="icon-footer-close"
        src="./img/icon_footer_close.png"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean
  }
};
</script>

<style scoped>
.footer-mask-component {
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 100;
  padding: 15px 0;
  width: 100%;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  .footer-mask-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .icon-footer-logo {
      width: 413px;
      height: 38px;
    }
    .icon-footer-wechatmini {
      width: 168px;
      height: 100px;
    }
  }
  .footer-close-image {
    position: absolute;
    right: 50px;
    top: 50px;
    cursor: pointer;
  }
  .icon-footer-close {
    width: 30px;
    height: 30px;
  }
}
.box {
  margin: 0 auto;
  width: 1200px;
}
</style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/welcome/components/footer-mask.vue